// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kIsPS7jpL3dUCs {
  background: var(--ds-background-accent-gray-subtlest, #f1f2f4);
}
.ZP4JSEmXvHw9rr {
  flex-grow: 0;
  flex-shrink: 0;
  margin: var(--ds-space-0, 0);
  padding: var(--ds-space-100, 8px);
  border-radius: var(--ds-border-radius-200, 8px);
  color: var(--accent-text, var(--ds-icon-subtle, #626f86));
}
.ZP4JSEmXvHw9rr:hover {
  background-color: var(--accent-background-hovered, var(--ds-background-neutral-hovered, #091e4224));
  color: var(--accent-text-bolder, var(--ds-icon, #44546f));
}
.ZP4JSEmXvHw9rr:active {
  background-color: var(--accent-background-pressed, var(--ds-background-neutral-pressed, #091e424f));
  color: var(--accent-text-bolder, var(--ds-icon, #44546f));
}
.ZP4JSEmXvHw9rr:visited,
.ZP4JSEmXvHw9rr:active {
  outline: none;
}
.ZP4JSEmXvHw9rr:focus {
  outline: -webkit-focus-ring-color auto 1px;
}
@media print {
  .ZP4JSEmXvHw9rr {
    display: none;
  }
}
`, ""]);
// Exports
export var popover = `kIsPS7jpL3dUCs`;
export var cardTemplateButton = `ZP4JSEmXvHw9rr`;
export default ___CSS_LOADER_EXPORT___;
